import { render, staticRenderFns } from "./StatisticCardHorizontalNoIcon.vue?vue&type=template&id=0f7fb06d&"
import script from "./StatisticCardHorizontalNoIcon.vue?vue&type=script&lang=js&"
export * from "./StatisticCardHorizontalNoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports